export default {
  C: "Do",
  CSharp: "Do♯",
  D: "Re",
  DFlat: "Re♭",
  DSharp: "Re♯",
  E: "Mi",
  EFlat: "Mi♭",
  F: "Fa",
  FSharp: "Fa♯",
  G: "Sol",
  GFlat: "Sol♭",
  GSharp: "Sol♯",
  A: "La",
  AFlat: "La♭",
  ASharp: "La♯",
  B: "Si",
  BFlat: "Si♭",

  correctExcl: "Correcto!",
  wrongExcl: "Errado!",

  ABORT: "ABORTAR",

  lastRound: "Última ronda",
  score: "Puntaje",
  accuracy: "Precisión",
  correct: "correcto",
  wrong: "errado",

  START: "EMPEZAR",
  settings: "Ajustes",
  ROUND_LENGTH: "LONGIDUD DE RONDA",
  NOTE_INPUT: "ENTRADA",
  CLEF: "CLAVE",
  DIFFICULTY: "DIFFICULDAD",
  ACCIDENTALS: "ACCIDENTALES",
  LANGUAGE: "IDIOMA",
  twentySeconds: "20 segundos",
  oneMinute: "1 minutos",
  fiveMinutes: "5 minutos",
  infinite: "Infinido",
  buttons: "Botones",
  piano: "Piano",
  trebleClef: "Sol",
  bassClef: "Fa",
  altoClef: "Alto",
  tenorClef: "Tenor",
  pianoClef: "Piano",
  easy: "Fácil",
  normal: "Medio",
  hard: "Duro",
  none: "Nada",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ and ♭",
  SOUND: "SONIDO",
  VIBRATION: "VIBRACIÓN",
  DISPLAYCORRECTNOTE: "MOSTRAR NOTA CORRECTA",
  on: "Encendido",
  off: "Apagado",

  TIME: "TIEMPO",
  CORRECT: "CORRECTO",
  ACCURACY: "PRECISIÓN",
  SCORE: "PUNTAJE",

  record: "Puntuación máxima",
  history: "Historia",

  noMidiSupport: "Lo siento, parece que su dispositivo no admite MIDI.",
  noDeviceFound: "Ningún dispositivo encontrado. Vuelva a conectar el dispositivo MIDI.",
  playTheNote: "Toca la nota en tu teclado MIDI.",
  lastNotePlayed: "Última nota tocada",
};



// WEBPACK FOOTER //
// ./src/resources/es.js